//import React from 'react';
// 3) HELMET - Add this import to each page
import React, { Fragment, useRef, useLayoutEffect, useState, useEffect} from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { NavLink } from 'react-router-dom';

import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import {ScrollTrigger} from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);
import { Physics2DPlugin } from "gsap/Physics2DPlugin";
gsap.registerPlugin(Physics2DPlugin);

// Import Images
import heroimg_home from '../images/heros/home.webp'; // Tell webpack this JS file uses this image

// Butterfly
import heroimg_butterfly_lwing from '../images/heros/buttefly-wing-left.webp';
import heroimg_butterfly_rwing from '../images/heros/buttefly-wing-right.webp';
import heroimg_butterfly_body from '../images/heros/butterfly-body.webp';
import heroimg_butterfly_fx_code from '../images/heros/buttefly-wing-fx-code.webp'; // to be deleted since we had 2 layer and one works best
import heroimg_butterfly_fx_code_top from '../images/heros/buttefly-wing-fx-code-top.webp';
import heroimg_butterfly_glitch_fx_1 from '../images/heros/butterfliy-glitch-effect-1.webp';
import heroimg_butterfly_glitch_fx_2 from '../images/heros/butterfliy-glitch-effect-2.webp';
import heroimg_butterfly_glitch_fx_3 from '../images/heros/butterfliy-glitch-effect-3.webp';
import heroimg_butterfly_glitch_fx_4 from '../images/heros/butterfliy-glitch-effect-4.webp';
import heroimg_butterfly_glitch_fx_5 from '../images/heros/butterfliy-glitch-effect-5.webp';
import heroimg_butterfly_glitch_fx_6 from '../images/heros/butterfliy-glitch-effect-6.webp';

import assurance_section_bg from '../images/home/assurance-bg.webp'; // for preloading since its a background image at 250KB

// Light rays FX bg
import light_rays from '../images/light-rays.svg'; 

import home_img_1 from '../images/home-services-graphic-design.webp'; 
import home_img_2 from '../images/home-services-web-development.webp'; 

// Graphic Design Slides
import gd_slide_1 from '../images/home/home-services-graphic-design-01.webp'; 
import gd_slide_2 from '../images/home/home-services-graphic-design-02.webp'; 
import gd_slide_3 from '../images/home/home-services-graphic-design-03.webp'; 
import gd_slide_4 from '../images/home/home-services-graphic-design-04.webp';
import gd_slide_5 from '../images/home/home-services-graphic-design-05.webp';  

// Web Development Slides
import wd_slide_1 from '../images/home/home-services-web-development-01.webp'; 
import wd_slide_2 from '../images/home/home-services-web-development-02.webp'; 
import wd_slide_3 from '../images/home/home-services-web-development-03.webp'; 
import wd_slide_4 from '../images/home/home-services-web-development-04.webp';
import wd_slide_5 from '../images/home/home-services-web-development-05.webp';  

// Assurance 
import assurance_pantone_book from '../images/home/assurance-pantone-book.webp';
import assurance_phone_pen from '../images/home/assurance-phone-pen.webp';  


/* FEATURED */
import home_featured_img_1 from '../images/featured/featured-graphic-design.webp'; 
import home_featured_img_2 from '../images/featured/featured-web-development.webp'; 


const Home = () => {
 const bgfx_ref_3 = useRef();

// ==========================================
// INITIAL ANIMATION CONTROLER
// Checks to see when the transtion animation is completed. ( when wee add the fill to BG )
// Use your timeline name below, add a paused:true, remove var/let/const defs! add ".current"
// ==========================================
const tl_hp_opening = useRef(null);
const [isTransitionDone, setIsTransitionDone] = useState(false);

useEffect(() => {
  // Direct load check (bookmarks / refreshes)
  const bg = document.querySelector("#smooth-content");

  const handleMasterDone = (e) => {

    // Transition, page to page
    if (e.detail?.pageID) {
      setIsTransitionDone(true);
      if (tl_hp_opening.current) {
        tl_hp_opening.current.play();
      }
    }
    // Transition: Initial Loading Of App
    if (e.detail?.pageidis) {
      setIsTransitionDone(true);
      if (tl_hp_opening.current) {
        gsap.delayedCall(4, () => tl_hp_opening.current?.play());
      }
    }

  };
  window.addEventListener('masterTransitionDone', handleMasterDone);
  return () => window.removeEventListener('masterTransitionDone', handleMasterDone);
}, []);
// ========================================== EOF Inital Animation Controller.




useGSAP(() => {
//<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< ===================================================== Update Scrolltrigger bug 8-24-2026  
// --- AT THE TOP OF useGSAP ---
  // 1. Force scroll to top immediately
  if (typeof sScroll !== 'undefined') {
    sScroll.scrollTo(0, false); 
  } else {
    window.scrollTo(0, 0);
  }

  // 2. Clear GSAP cached positions
  ScrollTrigger.clearScrollMemory();








  //Preset PAGE TRANSITION BACKGROUND
  gsap.set(".home-transition-curtain", {left:"-4000px", top:"-4000px"});



  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  // BUTTERFLY EFFECT - Hero
  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  let tl_buterfly_delay = gsap.timeline({delay:4});
  let tl_buterfly_wings = gsap.timeline({delay:4});
  let tl_buterfly_code = gsap.timeline({delay:4});
  let tl_butterfly_code_fade = gsap.timeline({delay:4});
  let randomDur;

  // CALL
  randomCall();
  // This randomly moves the wings every 1 - to - 6 seconds by calling it
  function randomCall(){
      randomDur = gsap.utils.random(1, 6);
      randomDur = Math.round(randomDur);
      tl_buterfly_delay.to(".butterfly-body", {duration: randomDur, onComplete: randomWings});
  }
  // Wing Movement Animation
  // ---------------------------------------- //
function randomWings() {
    tl_buterfly_wings.clear(); //<<<<<<<<<<<<<<< CHANGE (Clear previous run)
    
    tl_buterfly_wings
      // 1. Both wings open simultaneously after a 4-second delay
      .to(".wing-left", { duration: 1, rotationY: 45 }, "+=4") //<<<<<<<<<<<<<<< CHANGE (Clean timeline delay relative to start)
      .to(".wing-right", { duration: 1, rotationY: -45 }, "<") //<<<<<<<<<<<<<<< CHANGE ('<' forces exact same start time as previous tween)
      
      // 2. Both wings close simultaneously
      .to(".wing-left", { duration: 0.5, rotationY: 0 })
      .to(".wing-right", { duration: 0.5, rotationY: 0, onComplete: randomCall }, "<"); //<<<<<<<<<<<<<<< CHANGE ('<' forces exact same start time)
  }
  // CALL
  butterflyCode();

  // Presets for Butterlfy
  gsap.set(".wing-fx", { y: "-300px" });
  gsap.set(".wing-fx-top-code", { autoAlpha: 1 });

  // Wing Binary Code Visual Effects
  function butterflyCode(){
   tl_buterfly_code.to(".wing-fx", { duration: 6, x:0, y: "0px", ease: "none", onComplete:loopCodeFX });
  }

  // Reset the loop back binary animation
  function loopCodeFX(){
      gsap.set(".wing-fx", { y: "-300px" });
      gsap.set(".wing-fx-top-code", { autoAlpha: 1 });
      butterflyCode();
  }
  // Butterfly Keyboard Code Highlighting
  // ---------------------------------------- //
  // Using this Array, but this could be a method of geting trhe value with = gsap toArray('rect');
  const points = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37];

  // When this timeline completes, loop back. 
  let tlshuffle = gsap.timeline({onComplete:keyPressShuffle});  

  function keyPressShuffle() {  
    tlshuffle.clear(); // Empty previous tweens

    let i; 
    // Fisher Yates
    for ( i = points.length -1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i+1));
        let k = points[i];
        points[i] = points[j];
        points[j] = k;
    }


    // loop and asign animation
    for (let x = 0; x < points.length; x++) {
      tlshuffle.to("#ID_" + points[x], { autoAlpha: 1, duration: 0.2 })
               .to("#ID_" + points[x], { autoAlpha: 0, duration: 0.2 });
    }

  }// End Function


  // CALL
  keyPressShuffle();

  // GLITCH BUTTERFLY EFFECT
  // ---------------------------------------- //
  const images = document.querySelectorAll('.glitch-effect-wrapper img');
  const heroButterfly = document.querySelector('.hero-butterfly'); 
  const totalDuration = 0.5; 
  const frameDuration = totalDuration / images.length; 
  const getRandomRange = (min, max) => Math.random() * (max - min) + min;

  // 1. Hide all glitch images initially so they don't stack on top of each other
  gsap.set(images, { opacity: 0 });

  let tl_but_glitcher = gsap.timeline({ 
    paused: true,
    onStart: () => {
      // Hide the butterfly when the glitch starts
      gsap.set(heroButterfly, { opacity: 0 });
    },
    onComplete: () => {
      // 1. Bring the butterfly back when the glitch ends
      gsap.set(heroButterfly, { opacity: 1 });
      // 2. Schedule the next run
      const randomDelay = getRandomRange(3, 10);
      gsap.delayedCall(randomDelay, () => {
        tl_but_glitcher.restart();
      });
    }
  });

  images.forEach((img, index) => {
    const startTime = index * frameDuration;
    const endTime = (index + 1) * frameDuration;
    tl_but_glitcher.set(img, { opacity: 1 }, startTime);
    tl_but_glitcher.set(img, { opacity: 0 }, endTime);
  });

  // CALL
  tl_but_glitcher.play();

  //END OF HERO ANIMATIONS >>>>>>>>>

  // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
  // HERO PLAY CONTROLLER 
  // When scrolled past 800 pixels pasies, resumes when scollred back
  // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
  ScrollTrigger.create({
    trigger: "body",
    start: "300px top",
    onEnter: () => {
      tl_buterfly_delay.pause();
      tl_buterfly_wings.pause();
      tl_buterfly_code.pause();
      tl_butterfly_code_fade.pause();
      tl_but_glitcher.pause();
      tlshuffle.pause();
    },
    onLeaveBack: () => {
      tl_buterfly_delay.play();
      tl_buterfly_wings.play();
      tl_buterfly_code.play();
      tl_butterfly_code_fade.play();
      tl_but_glitcher.play();
      tlshuffle.play();
    }
  });


  // **********************************//
  // MATCH MEDIA MOBILE 
  // **********************************//
  let mm = gsap.matchMedia();
  // Desktop animation
  mm.add("(min-width: 800px)", () => {


  // ===============================//
  // INITIAL ANIMATIOM
  // ===============================//
  gsap.set(".opening-copy h2, .opening-copy p", {y:"30px", opacity:0 });  
  tl_hp_opening.current = gsap.timeline({paused:true});
  tl_hp_opening.current.to(".opening-copy h2", {duration:1, opacity:1, y:"0px"})  
  .to(".opening-copy p", {duration:1, opacity:1, y:"0px", delay:-0.5});  




  // HIGHLIGHT TEXT ANIMATIOM
  let splitHighlightOne = SplitText.create(".graphic-design h2", { type: "chars" });
  let splitHighlightTwo = SplitText.create(".web-development h2", { type: "chars" });

  // xxxxxxxxxxxxxxxxxxxxxxxxxxxx
  // PARTICLE FX FOR RIBBON REVEAL
  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  var emitter = document.querySelector(".emitter"),
      emitterSize = 30,
      dotPool = [],
      dotIndex = 0,
      dotQuantity = 30,
      dotSizeMax = 30,
      dotSizeMin = 10,
      speed = 1,
      gravity = 1;

     var emitter2 = document.querySelector(".emitter-2"),
      emitterSize2 = 30,
      dotPool2 = [],
      dotIndex2 = 0,
      dotQuantity2 = 30,
      dotSizeMax2 = 30,
      dotSizeMin2 = 10,
      speed2 = 1,
      gravity2 = 1; 

  if (emitter) gsap.set(emitter, { width:emitterSize, height:emitterSize, xPercent:-50, yPercent:-50 });
  if (emitter2) gsap.set(emitter2, { width:emitterSize, height:emitterSize2, xPercent:-50, yPercent:-50 });

  if (emitter) {
    for (var i = dotQuantity - 1; i >= 0; i--) {
      let dot = document.createElement("div");
      dot.className = "dot";
      emitter.appendChild(dot);
      dotPool[i] = dot;
    }
  }

  if (emitter2) {
    for (var i = dotQuantity2 - 1; i >= 0; i--) {
      let dot2 = document.createElement("div");
      dot2.className = "dot2";
      emitter2.appendChild(dot2);
      dotPool2[i] = dot2;
    }
  }

  var explosion = gsap.timeline({repeat: -1, paused: true}).call(shootDot, [emitter], 2 / dotQuantity);  
  var explosion2 = gsap.timeline({repeat: -1, paused: true}).call(shootDot2, [emitter2], 2 / dotQuantity2);  
      
  function shootDot(emitter) {
    if (!emitter) return;
    var angle, length, dot, size = emitter.getBoundingClientRect();
    dot = dotPool[dotIndex++];
    if (dotIndex === dotQuantity) dotIndex = 0;
    size = getRandom(dotSizeMin, dotSizeMax);
    angle = Math.random() * Math.PI * 2;
    length = Math.random() * (emitterSize / 2 - size / 2); 
    gsap.set(dot, {
      opacity:1,
      x:0,
      y:0,
      width:size,
      height:size
    });
    gsap.to(dot, {
      duration: 1 + Math.random(),
      opacity:0,
      physics2D:{
        angle:angle * 180 / Math.PI,
        velocity:(100 + Math.random() * 250) * speed,
        gravity:500 * gravity
      }
    });
  }

  function shootDot2(emitter2) {
    if (!emitter2) return;
    var angle, length, dot2, size = emitter2.getBoundingClientRect();
    dot2 = dotPool2[dotIndex2++];
    if (dotIndex2 === dotQuantity2) dotIndex2 = 0;
    size = getRandom(dotSizeMin2, dotSizeMax2);
    angle = Math.random() * Math.PI * 2;
    length = Math.random() * (emitterSize / 2 - size / 2); 
    gsap.set(dot2, {
      opacity:1,
      x:0,
      y:0,
      width:size,
      height:size
    });
    gsap.to(dot2, {
      duration: 1 + Math.random(),
      opacity:0,
      physics2D:{
        angle:angle * 180 / Math.PI,
        velocity:(100 + Math.random() * 250) * speed2,
        gravity:500 * gravity2
      }
    });
  }

  function getRandom(min, max) {
    return min + Math.random() * (max - min);
  }   

  let sw = window.innerWidth; 
  gsap.set("#emitter-cab", { x:'-'+sw+'px', }); 
  gsap.set("#emitter-cab-2", { x:'-'+sw+'px', }); 

  function startParticleFx(){
    explosion.play();
  }   
  function stopParticleFx(){
    explosion.pause();
  }
  function startParticleFx2(){
    explosion2.play();
  }   
  function stopParticleFx2(){
    explosion2.pause();
  }


   // xxxxxxxxxxxxxxxxxxxxxxxxxxxxx
   // FIRST SCROLL ANIMATION
   // xxxxxxxxxxxxxxxxxxxxxxxxxxxxx
   gsap.set(".graphic-design .work-heading-fx h2 span:first-child", {opacity:0 });  
   gsap.set(".graphic-design .work-heading-fx h2 span:last-child", {opacity:0 }); 
   gsap.set(splitHighlightOne.chars, {y:50, opacity:0});
   gsap.set(".bg-ribbon-wrap", {opacity:0 });
   gsap.set(".bg-ribbon-wrap-2", {opacity:0 });
   gsap.set(".graphic-design p", {y:"20px", opacity:0});
   gsap.set(".web-development p", {y:"20px", opacity:0});

  let tl_hp_sect_1 = gsap.timeline({
    paused:true,
    scrollTrigger: {
      trigger: ".vx1",
      start: "top top+=10%",
      scrub: true,
      pin: true,
      pinSpacing: true,
      end: "bottom+=2000px",
      markers: false,
      invalidateOnRefresh: true,
      preventOverlaps: true,
      fastScrollEnd: true,
    }
  })
  tl_hp_sect_1.to(".gd-slide-5", {duration: 1.5, autoAlpha: 0, onStart: playSect1Anmation}) 
  .to(".gd-slide-4", {duration: 1.5, autoAlpha: 0}, "+=1.5")
  .to(".gd-slide-3", {duration: 1.5, autoAlpha: 0}, "+=1.5") 
  .to(".gd-slide-2", {duration: 1.5, autoAlpha: 0}, "+=1.5");

      
  function playSect1Anmation(){
    tl_hp_sect_1_animation.play();
  }
  let tl_hp_sect_1_animation = gsap.timeline({paused:true});

  tl_hp_sect_1_animation
    .to(".bg-ribbon-wrap", {duration:0.001, opacity:1,})
    .to("#emitter-cab", {
      duration: 3,
      motionPath: {
        path: ".pathway", 
        align: ".pathway",
        alignOrigin: [0, 0.5],
        ease: "power4.out",
      },
      onStart:startParticleFx,
      onComplete:stopParticleFx,
    })
    .to(".graphic-design .work-heading-fx h2 span:first-child", { duration: 0.5, autoAlpha:1, delay:-3})
    .to(".graphic-design .work-heading-fx h2 span:last-child", {duration:0.5, autoAlpha:1, delay:-3})
    .to(splitHighlightOne.chars, {y:0, opacity:1, duration:0.20, delay:-3, stagger: {
            each: 0.10,
            from: "random"
          },})
    .to(".graphic-design p", { duration: 1.5, y:0, autoAlpha:1, delay:-3});


  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  // SECOND SCROLL ANIMATION
  // xxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  gsap.set(".web-development .work-heading-fx-2 h2 span:first-child", {opacity:0 });  
  gsap.set(".web-development .work-heading-fx-2 h2 span:last-child", {opacity:0 }); 

  gsap.set(splitHighlightTwo.chars, {y:50, opacity:0});

  let tl_hp_sect_2 = gsap.timeline({
      scrollTrigger: {
        trigger: ".vx2",
        start: "top top+=10%",
        scrub: true,
        pin: ".vx2",
        pinSpacing: true,
        end: "bottom+=1000px",
        markers: false
      }
    })
   .to(".wd-slide-5", {duration:1.5, autoAlpha:0, onStart:playSect2Anmation}) 
    .to(".wd-slide-4", {duration:1.5, autoAlpha:0}, "+=1.5")
    .to(".wd-slide-3", {duration:1.5, autoAlpha:0}, "+=1.5")
    .to(".wd-slide-2", {duration:1.5, autoAlpha:0}, "+=1.5");


  function playSect2Anmation(){
    tl_hp_sect_2_animation.play();
  }

  let tl_hp_sect_2_animation = gsap.timeline({paused:true});
  tl_hp_sect_2_animation
    .to(".bg-ribbon-wrap-2", {duration:0.001, opacity:1})  
    .to("#emitter-cab-2", {
      opacity:1,
      duration: 3,
      motionPath: {
        path: ".pathway-2", 
        align: ".pathway-2",
        alignOrigin: [0, 0.5],
        ease: "power4.out",
      },
      onStart:startParticleFx2,
      onComplete:stopParticleFx2,
    })
    .to(".web-development .work-heading-fx-2 h2 span:first-child", {duration: 0.1, autoAlpha:1, delay:-3})
    .to(".web-development .work-heading-fx-2 h2 span:last-child", {duration:0.1, autoAlpha:1, delay:-3})
    .to(splitHighlightTwo.chars, {y:0, opacity:1, duration:0.20, delay:-3, stagger: {
            each: 0.10,
            from: "random"
          }, })
    .to(".web-development p", { duration: 1.5, y:0, autoAlpha:1, delay:-3});


  // ----------------------------------
  // ASSURANCE SECTION
  // ---------------------------------
  gsap.set('.assurance-copy p', {color: "rgba(255, 255, 255, 0.3)"});

  const mySplitText = new SplitText(".assurance-copy p", { 
    type: "words, chars",
    charsClass: "is-char" 
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".assurance",
      start: "top top+=20%",
      end: "bottom+=10%", 
      scrub: true,
      pin: true,
      anticipatePin: 1
    }
  });

  tl.to(mySplitText.chars, {
    rotationZ:360,
    color: "rgba(255, 255, 255, 1)",   
    stagger: 0.03,      
    duration: 0.25,
    ease: "none"
  });

  // CANVAS GRID
  // ---------------------------------//
  const canvas = document.querySelector("#ip-hero-canvas");
  let handleResize;
  let particles = [];
  let tick;

  if (canvas) {
    const ctx = canvas.getContext("2d");
    let canvasWidth = canvas.width;
    let canvasHeight = canvas.height;
    const numberOfParticles = 100;
    const maxAlpha = 0.5;

    class Particle {
      constructor() {
        const maxGridX = Math.floor(canvasWidth / 25);
        const maxGridY = Math.floor(canvasHeight / 25);

        this.x = Math.floor(Math.random() * maxGridX) * 25;
        this.y = Math.floor(Math.random() * maxGridY) * 25;
        this.size = 25;
        this.alpha = 0; 

        this.animate();
      }
      animate() {
        gsap.to(this, {
          alpha: Math.random() * maxAlpha, 
          duration: gsap.utils.random(1, 3),
          delay: gsap.utils.random(0, 2),
          yoyo: true,
          repeat: -1,
          ease: "sine.inOut",
          onRepeat: () => {
            const maxGridX = Math.floor(canvasWidth / 25);
            const maxGridY = Math.floor(canvasHeight / 25);
            this.x = Math.floor(Math.random() * maxGridX) * 25;
            this.y = Math.floor(Math.random() * maxGridY) * 25;
          }
        });
      }
      draw(ctx) {
        if (this.alpha <= 0) return; 

        ctx.save();
        ctx.globalAlpha = this.alpha;
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(this.x, this.y, this.size, this.size);
        ctx.restore();
      }
    }

    function createParticles() {
      for (let i = 0; i < numberOfParticles; i++) {
        particles.push(new Particle());
      }
    }
    createParticles();

    tick = () => {
      ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      for (let i = 0; i < particles.length; i++) {
        particles[i].draw(ctx);
      }
    };
    gsap.ticker.add(tick);

    handleResize = () => {
      canvasWidth = canvas.width = canvas.getBoundingClientRect().width;
      canvasHeight = canvas.height = canvas.getBoundingClientRect().height;
    };
    window.addEventListener("resize", handleResize);
  }

  // -----------------------------------
  // Featured Design works Animation 
  // ----------------------------------
  gsap.set('.fw-graphic-design', {scale:0.5, rotationY:45, transformStyle:"preserve-3d", autoAlpha:0, transformOrigin: '50% right'  });
  gsap.set('.fw-web-development', {scale:0.5, rotationY:-45, transformStyle:"preserve-3d", autoAlpha:0, transformOrigin: '50% left' });

  let tlfeatured = gsap.timeline({
    scrollTrigger: {
      trigger: ".featured-work",
      start: "top center-=12%",
      end: "+=1000px",
      toggleActions: "play none none none",
      markers: false
    }
  })
    .to('.fw-graphic-design', {duration:1, autoAlpha:1, rotationY:0, scale:1, ease: "power1.out"})
    .to('.fw-web-development', {duration:1, autoAlpha:1, rotationY:0, scale:1, ease: "power1.out", delay:-1 })
    .to('.fxb-right', {duration:1, height:"100%", ease: "power1.out", delay:-0.25})
    .to('.fxb-bottom', {duration:1, width:"100%", ease: "power1.out", delay:-1.25})
    .to('.fxb-left', {duration:1, height:"100%", ease: "power1.out", delay:-1.25 })
    .to('.fxb-top', {duration:1, width:"100%", ease: "power1.out", delay:-1.25 });
       
  // ROLLOVERS
  const spotlightContainers = document.querySelectorAll('.spotlight-cab-1, .spotlight-cab-2');

  spotlightContainers.forEach(container => {
    const lightRays = container.querySelector('.light-rays-fx');
    const thumbImage = container.querySelector('img');

    if (!lightRays) return;

    const spinTimeline = gsap.to(lightRays, {
      rotation: 360,
      duration: 10,      
      repeat: -1,        
      ease: "none",     
      paused: true
    });

    gsap.set(lightRays, { opacity: 0 });

    container.addEventListener('mouseenter', () => {
      spinTimeline.play();
      gsap.to(lightRays, {
        scale:1,
        opacity: 1,
        duration: 0.4,
        ease: "power2.out"
      });
      gsap.to(thumbImage, {
        scale:1.1,
        duration: 0.4,
        ease: "power2.out"
      });
    });

    container.addEventListener('mouseleave', () => {
      gsap.to(lightRays, {
        scale:0,
        opacity: 0,
        duration: 0.4,
        ease: "power2.in",
        onComplete: () => spinTimeline.pause()
      });
      gsap.to(thumbImage, {
        scale:1,
        duration: 0.4,
        ease: "power2.out"
      });

    });
  });


  return () => {
      // Cleanup for mobile/desktop elements
      if (tick) gsap.ticker.remove(tick);
      if (handleResize) window.removeEventListener("resize", handleResize);
      particles.forEach(p => gsap.killTweensOf(p));
    };

  }); // END of MATCH MEDIA MOBILE =  800 <<< XXXXXXXXXXXXX



//<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< ===================================================== Update Scrolltrigger bug 8-24-2026  
// --- AT THE BOTTOM OF useGSAP ---
  // 3. Wait 1 render frame for CRA to paint, re-verify 0px, and refresh markers
  requestAnimationFrame(() => {
    if (typeof sScroll !== 'undefined') {
      sScroll.scrollTo(0, false); 
    } else {
      window.scrollTo(0, 0);
    }
    ScrollTrigger.refresh();
  });




}, { scope: bgfx_ref_3 });
// End of useGSAP























  
// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
// HTML CODE 
// XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

  return (
  
<main className="page-content page-id_home" data-page-id="home" ref={bgfx_ref_3}>

<HelmetProvider> 
<Fragment> 
      <Helmet>
        <title>Miami Graphic Designer & Web Developer | Mark Hawkins</title>
        <meta name="description" content="Professional graphic designs and web development by Mark Hawkins. View this online portfolio."/>


         <meta property="og:image" content="https://www.markhawkinsdesigns.com/mark-hawkins-designs-listing-hero.webp" />
         <meta property="og:image:secure_url" content="https://www.markhawkinsdesigns.com/mark-hawkins-designs-listing-hero.webp" />
         <meta property="og:image:type" content="image/webp" />
         <meta property="og:image:width" content="1200" />
         <meta property="og:image:height" content="900" />
         <meta property="og:image:alt" content="A description of your home page image" />


      </Helmet>
</Fragment>
</HelmetProvider>

<svg version="1.1" className="home-transition-curtain transition-curtain" x="0px" y="0px"viewBox="0 0 191 191" xmlSpace="preserve">
<path className="st0" d="M95.5,190.5c-52.4,0-95-42.6-95-95s42.6-95,95-95s95,42.6,95,95S147.9,190.5,95.5,190.5z"/>
<path className="st1" d="M95.5,1C147.6,1,190,43.4,190,95.5S147.6,190,95.5,190S1,147.6,1,95.5S43.4,1,95.5,1 M95.5,0
	C42.8,0,0,42.8,0,95.5S42.8,191,95.5,191S191,148.2,191,95.5S148.2,0,95.5,0L95.5,0z"/>
</svg>

<div className="hero-container-wrap"> 
<div className='hero-container'>
  <div className="hero-mask">

  <div className='mask-svg'>
    <svg viewBox="0 0 0 0" height="0" width="0">
      <defs> 
          <clipPath id="clipping" clipPathUnits="objectBoundingBox" transform="scale(0.00099, 0.00105)"> 
              <path id="dotmask" d="M853,0c0,357.9-290.1,648-648,648c-71.6,0-140.6-11.6-205-33.1v158.6C65.4,790.8,134.1,800,205,800
			c441.8,0,800-358.2,800-800H853z"/>
              <path id="hoopmask"  d="M0,0v501.1c63.2,25.9,132.4,40.2,205,40.2c298.9,0,541.3-242.3,541.3-541.3H0z"/>
	        </clipPath>
      </defs> 
    </svg>
  </div>
 
    

 { /* hero image to be masked container  */ }
   <div className="heroimage">



 { /* glitch Effect - floats above butterfly  - stack these images in their own container. */ }
<div className="butterfly-glitch-effect">
        <div className="glitch-effect-wrapper">
          <img src={heroimg_butterfly_glitch_fx_1} className="glitch-frame-1" alt="glitch effect 1" />
          <img src={heroimg_butterfly_glitch_fx_2} className="glitch-frame-2" alt="glitch effect 2" />
          <img src={heroimg_butterfly_glitch_fx_3} className="glitch-frame-3" alt="glitch effect 3" />
          <img src={heroimg_butterfly_glitch_fx_4} className="glitch-frame-4" alt="glitch effect 4" />
          <img src={heroimg_butterfly_glitch_fx_5} className="glitch-frame-5" alt="glitch effect 5" />
          <img src={heroimg_butterfly_glitch_fx_6} className="glitch-frame-6" alt="glitch effect 6" />
      </div>
</div>



 { /* butterfly - floats absolute above  */ }
        <div className="hero-butterfly">
          <div className="butterfly-container"> 

            <div className="wing-body">
              <div className="wing-left">
                { /* FX binary code image - to be clipped ( masked )  */ } 
                <div className="left-fx-clip">
           
                  <div className="wing-fx">
                        <img className="wing-fx-top-code" src={heroimg_butterfly_fx_code_top } alt="wing code top" />
                   </div>

                </div>
                <img src={heroimg_butterfly_lwing} alt="butterfly wing left" />
                </div>
            </div>

            <div className="wing-body">
              <div className="wing-right">
                  { /* FX binary code image - to be clipped ( masked )  */ } 
                <div className="right-fx-clip">

                  <div className="wing-fx">
                        <img className="wing-fx-bottom-code" src={heroimg_butterfly_fx_code_top } alt="wing code bottom" />
                  </div>

                </div>
                <img src={heroimg_butterfly_rwing} alt="butterfly wing right" />
             </div>
            </div>

		    <img className="butterfly-body" src={heroimg_butterfly_body} alt="butterfly body" />  
          </div>
        </div> 


 <svg version="1.1" x="0px" y="0px" viewBox="0 0 2400 1700" className="hero-keyboard-highlights">
<g id="KEYS">
	<path id="ID_1" className="st1" d="M152.2,718.7l-19-132.4c-1.2-8.7-9.3-14.7-17.9-13.4L0,589.5v167.1l138.8-19.9
		C147.5,735.5,153.5,727.4,152.2,718.7z"/>
	<path id="ID_2" className="st1" d="M331.5,709.1l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C346.2,699.8,340.2,707.8,331.5,709.1z"/>
	<path id="ID_3" className="st1" d="M536.6,679.6l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C551.3,670.4,545.3,678.4,536.6,679.6z"/>
	<path id="ID_4" className="st1" d="M736.6,651l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C751.3,641.7,745.3,649.7,736.6,651z"/>
	<path id="ID_5" className="st1" d="M944,621.2l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C958.7,611.9,952.7,620,944,621.2z"/>
	<path id="ID_6" className="st1" d="M1147.9,592l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1162.5,582.7,1156.5,590.7,1147.9,592z"/>
	<path id="ID_7" className="st1" d="M1354.4,562.4l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1369.1,553.1,1363.1,561.1,1354.4,562.4z"/>
	<path id="ID_8" className="st1" d="M1552.9,533.9l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1567.6,524.6,1561.6,532.6,1552.9,533.9z"/>
	<path id="ID_9" className="st1" d="M1754.1,505l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1768.8,495.8,1762.8,503.8,1754.1,505z"/>
	<path id="ID_10" className="st1" d="M1958,475.8l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1972.7,466.5,1966.7,474.6,1958,475.8z"/>
	<path id="ID_11" className="st1" d="M259.8,927.1l-144,20.7
		c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4
		C274.5,917.8,268.5,925.8,259.8,927.1z"/>
	<path id="ID_12" className="st1" d="M467.7,897.3l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C482.4,888,476.3,896,467.7,897.3z"/>
	<path id="ID_13" className="st1" d="M666.2,868.8l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C680.9,859.5,674.8,867.6,666.2,868.8z"/>
	<path id="ID_14" className="st1" d="M875.5,838.8l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		L852,675c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C890.1,829.5,884.1,837.6,875.5,838.8z"/>
	<path id="ID_15" className="st1" d="M1076.3,810l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1091,800.7,1084.9,808.8,1076.3,810z"/>
	<path id="ID_16" className="st1" d="M1283.7,780.2l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1298.4,771,1292.4,779,1283.7,780.2z"/>
	<path id="ID_17" className="st1" d="M1490,750.7l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1504.6,741.4,1498.6,749.4,1490,750.7z"/>
	<path id="ID_18" className="st1" d="M1688.8,722.2l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1703.5,712.9,1697.5,720.9,1688.8,722.2z"/>
	<path id="ID_19" className="st1" d="M1890,693.3L1746,714c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1904.7,684,1898.7,692.1,1890,693.3z"/>
	<path id="ID_20" className="st1" d="M2097.4,663.6l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C2112.1,654.3,2106.1,662.3,2097.4,663.6z"/>
	<path id="ID_21" className="st1" d="M360.1,1114.9l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C374.8,1105.6,368.7,1113.7,360.1,1114.9z"/>
	<path id="ID_22" className="st1" d="M550.5,1087.6l-144,20.7
		c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4
		C565.2,1078.3,559.1,1086.4,550.5,1087.6z"/>
	<path id="ID_23" className="st1" d="M757.1,1058l-144,20.7
		c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4
		C771.8,1048.7,765.7,1056.7,757.1,1058z"/>
	<path id="ID_24" className="st1" d="M961.5,1028.7l-144,20.7
		c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4
		C976.2,1019.4,970.2,1027.4,961.5,1028.7z"/>
	<path id="ID_25" className="st1" d="M1161.9,999.9l-144,20.7
		c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4
		C1176.6,990.6,1170.6,998.7,1161.9,999.9z"/>
	<path id="ID_26" className="st1" d="M1364.6,970.8l-144,20.7
		c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4
		C1379.3,961.6,1373.3,969.6,1364.6,970.8z"/>
	<path id="ID_27" className="st1" d="M1565.6,939.3l-144,20.7
		c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4
		C1580.3,930,1574.3,938,1565.6,939.3z"/>
	<path id="ID_28" className="st1" d="M1766.8,910.4l-144,20.7
		c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4
		C1781.5,901.1,1775.5,909.2,1766.8,910.4z"/>
	<path id="ID_29" className="st1" d="M1968,881.6l-144,20.7
		c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4
		C1982.7,872.3,1976.7,880.3,1968,881.6z"/>
	<path id="ID_30" className="st1" d="M486.7,1302.7l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C501.4,1293.5,495.4,1301.5,486.7,1302.7z"/>
	<path id="ID_31" className="st1" d="M690.6,1273.5l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C705.3,1264.2,699.3,1272.3,690.6,1273.5z"/>
	<path id="ID_32" className="st1" d="M889.1,1245l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C903.8,1235.8,897.8,1243.8,889.1,1245z"/>
	<path id="ID_33" className="st1" d="M1091.1,1216.1l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1105.8,1206.8,1099.8,1214.8,1091.1,1216.1z"/>
	<path id="ID_34" className="st1" d="M1299,1188.4l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1313.7,1179.2,1307.7,1187.2,1299,1188.4z"/>
	<path id="ID_35" className="st1" d="M1490,1158.9l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1504.6,1149.6,1498.6,1157.6,1490,1158.9z"/>
	<path id="ID_36" className="st1" d="M1688.8,1127.9l-144,20.7c-8.7,1.2-16.7-4.8-17.9-13.4l-19-132.4c-1.2-8.7,4.8-16.7,13.4-17.9
		l144-20.7c8.7-1.2,16.7,4.8,17.9,13.4l19,132.4C1703.5,1118.6,1697.5,1126.6,1688.8,1127.9z"/>
	<path id="ID_37" className="st1" d="M1732.6,1358.5l-943.3,135.3
		c-8.7,1.2-16.7-4.8-17.9-13.4l-23.5-163.7c-1.2-8.7,4.8-16.7,13.4-17.9l943.3-135.3c8.7-1.2,16.7,4.8,17.9,13.4l23.5,163.7
		C1747.3,1349.2,1741.3,1357.2,1732.6,1358.5z"/>
</g>
</svg>

        { /* hero image  */ }    
      <img src={heroimg_home} alt="background image of keyboard" />
   </div>



  </div>

  <div className='hero-text'>
    <div className="page-h1">
     <h1 style={{ opacity: 0, visibility: 'hidden' }}>Designs</h1>
     <div className="h1-accent"><span></span></div>
    </div>
    <strong>By Mark Hawkins</strong>
  </div>
</div>
</div>







<div className="home">


<section className="opening-copy">
  <h2>Innovative Visionary, Senior Designer & Web Developer</h2>
  <p>Crafting high-performance digital experiences where design meets motion and creative engineering.</p>
</section>




  <section className="opening">
 <strong>SPECIALIZING IN</strong>
   </section>



<section className="sect vx1 opening-graphic-design-services">
<div className="bg-ribbon-wrap">
    <svg id="bg-ribbon" xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" version="1.2" viewBox="0 0 1920 394.7">
		   <path className="ribbon-vector-graphic" d="M0,184.7S372.7-41.2,764,6.7c269.7,33,601.3,368.3,843,345,210.8-20.4,313-142,313-142v91.7s-126.3,93.3-326.3,93.3S1027.9,109.8,731,66.3C432.4,22.6,0,334.7,0,334.7v-150Z" stroke="#fff" strokeMiterlimit="10" />		
   </svg>
  	  
   <svg id="path-example" baseProfile="tiny" version="1.2" viewBox="0 0 1920 394.7">
     <path className="pathway" d="M0,184.7S372.7-41.2,764,6.7c269.7,33,601.3,368.3,843,345,210.8-20.4,313-142,313-142" fill="none" stroke="#46d170" strokeMiterlimit="10"/>
   </svg>

   <div id="emitter-cab">
	    <div className="emitter"></div>
   </div>	  	  
</div>	


    <div className="layout-columns graphic-design">
      <div className="work-assets">       
       <div className="img-cab"> 
   

        {/*  Monitor Images in Slider Animation  */}
        <div className="monitor-slide-1">
          <img src={ gd_slide_1} className="gd-slide-5" alt="Graphic Design Example One" />
          <img src={ gd_slide_2} className="gd-slide-4" alt="Graphic Design Example Two" />
          <img src={ gd_slide_3} className="gd-slide-3" alt="Graphic Design Example Three" />
          <img src={ gd_slide_4} className="gd-slide-2" alt="Graphic Design Example Four" />
          <img src={ gd_slide_5} className="gd-slide-1" alt="Graphic Design Example Five" />
           {/*  The Monitor Image  */}
           <img img src={home_img_1} className="monitor-img" alt="Graphic Design Services picutre of monitor" />
        </div>
    </div> 

   
  </div>

  <div className="work-content">
         <div className="work-heading-fx">
          <h2>
            <span>Graphic</span>
            <span>Design</span>
          </h2> 
        </div>
      <p>Elevated branding and marketing design services for both digital and print.</p>
  </div>

</div>  
</section>






<section className="sect vx2 opening-web-development-services">


<div className="bg-ribbon-wrap-2">
    <svg id="bg-ribbon-2" xmlns="http://www.w3.org/2000/svg" baseProfile="tiny" version="1.2" viewBox="0 0 1920 394.7">
		   <path className="ribbon-vector-graphic" d="M0,184.7S372.7-41.2,764,6.7c269.7,33,601.3,368.3,843,345,210.8-20.4,313-142,313-142v91.7s-126.3,93.3-326.3,93.3S1027.9,109.8,731,66.3C432.4,22.6,0,334.7,0,334.7v-150Z" stroke="#fff" strokeMiterlimit="10" />		
   </svg>
  	  
   <svg id="path-example-2" baseProfile="tiny" version="1.2" viewBox="0 0 1920 394.7">
     <path className="pathway-2" d="M0,184.7S372.7-41.2,764,6.7c269.7,33,601.3,368.3,843,345,210.8-20.4,313-142,313-142" fill="none" stroke="#46d170" strokeMiterlimit="10"/>
   </svg>

   <div id="emitter-cab-2">
	    <div className="emitter-2"></div>
   </div>	  	  
</div>	


  <div className="layout-columns web-development">
    <div className="work-assets">
      <div className="img-cab">
      {/* Monitor Slide 1 (masked) */}
     <div className="monitor-slide-2">
        <img src={ wd_slide_1 } className="wd-slide-5" alt="Web Development Example Five" />
        <img src={ wd_slide_2 } className="wd-slide-4" alt="Web Development Example Four" />
        <img src={ wd_slide_3 } className="wd-slide-3" alt="Web Development Example Three" />
        <img src={ wd_slide_4 } className="wd-slide-2" alt="Web Development Example Two" />
        <img src={ wd_slide_5 } className="wd-slide-1" alt="Web Development Example One" />
        {/*  Monitor Image  */}
         <img src={home_img_2} className="monitor-img" alt="Web Development Services - picture of monitor" />
     </div>
    </div>
    </div>

   <div className="work-content">
      <div className="work-heading-fx-2">
          <h2>
           <span>Web</span>
          <span>Development</span>
       </h2> 
    </div>
     <p>Customer-experience-focused corporate and e-commerce web solutions.</p>
    </div>
  </div>
</section>






<section className="assurance">

  <div className="assurance-wrapper">
      <div className="assurance-copy">
       <p>Bridging design, digital experiences, and full-stack development with over two decades of expertise.</p>
     </div>
      <img img src={assurance_pantone_book} className="pantone-book" alt="Pantone Book" />
      <img img src={assurance_phone_pen} className="phone-pen" alt="Phone" />
   </div>

          <canvas id="ip-hero-canvas" width="2550" height="600"></canvas>
          
</section>








<section className="featured-work-wrapper">
  <div className="featured-work">
<h2>Featured Design Works</h2>
<div className="spotlight-wrapper">

   <div className="spotlight-cab-1">
      <div className="spotlight-img-border fw-graphic-design">
      <NavLink  to="/portfolio/logo-design_id-74">
        <div className="featured-img-wrap-1"><img src={home_featured_img_1} className="graphic-design-monitor" alt="Featured Graphic Design" />
        </div>
        <strong>Graphic Design  <span>Natures Element</span></strong>
          <span className="fxborder fxb-top"></span>
          <span className="fxborder fxb-right"></span>
          <span className="fxborder fxb-bottom"></span>
          <span className="fxborder fxb-left"></span>
      </NavLink>

                   <div className="light-rays-fx">
                      <img src={light_rays} alt="FX" />
                   </div>  
      </div>
   </div>

   <div className="spotlight-cab-2"> 
   <div className="spotlight-img-border fw-web-development">
   <NavLink  to="/portfolio/custom-wordpress-theme-id-21">
      <div className="featured-img-wrap-2"><img src={home_featured_img_2} className="graphic-design-monitor" alt="Featured Web Development" /></div>
      <strong>Web Development <span>WordPress Custom Theme</span></strong>
          <span className="fxborder fxb-top"></span>
          <span className="fxborder fxb-right"></span>
          <span className="fxborder fxb-bottom"></span>
          <span className="fxborder fxb-left"></span>
          </NavLink>

                   <div className="light-rays-fx">
                      <img src={light_rays} alt="FX" />
                   </div>

     </div>
   </div>




           {/*  The Monitor Light FX behind it  */}
      
  
           

</div>
</div>
</section>









  </div>
</main>

  );
};

export default Home;
